import React, { useState } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { BookOpenIcon, CheckIcon, ClockIcon, AwardIcon, UsersIcon, ShieldCheckIcon, ChevronRightIcon, ChevronDownIcon, StarIcon, CheckCircleIcon, ArrowRightIcon, PlusIcon, MinusIcon, GraduationCapIcon, CreditCardIcon, AlertCircleIcon, ScrollIcon, MapPinIcon, CalendarIcon, ClipboardCheckIcon, BuildingIcon, LightbulbIcon, BriefcaseIcon, UserIcon, TargetIcon, FileTextIcon } from 'lucide-react';
export const HACCPFoodSafetyNewDesign = () => {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-1223">
      <Header data-id="element-1224" />
      <main className="flex-grow" data-id="element-1225">
        <HeroSection data-id="element-1226" />
        <TargetAudienceSection data-id="element-1227" />
        <LegalRequirementsSection data-id="element-1228" />
        <LearningOutcomesSection data-id="element-1229" />
        <CertificationSection data-id="element-1230" />
        <WhyChooseUsSection data-id="element-1231" />
        <FaqSection data-id="element-1232" />
        <CtaSection data-id="element-1233" />
      </main>
      <Footer data-id="element-1234" />
    </div>;
};
const HeroSection = () => {
  return <section className="relative pt-28 pb-20 md:pt-32 md:pb-24 bg-gradient-to-b from-emerald-950 to-emerald-900 overflow-hidden" data-id="element-1235">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-1236">
        <div className="absolute top-1/4 -right-24 w-96 h-96 rounded-full bg-emerald-600/20 blur-3xl" data-id="element-1237"></div>
        <div className="absolute bottom-1/3 -left-24 w-80 h-80 rounded-full bg-emerald-400/10 blur-3xl" data-id="element-1238"></div>
      </div>
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-5 mix-blend-overlay" data-id="element-1239">
        <div className="absolute inset-0" style={{
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
        backgroundSize: '24px 24px'
      }} data-id="element-1240"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-1241">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12" data-id="element-1242">
          <div className="max-w-2xl" data-id="element-1243">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-6 shadow-lg" data-id="element-1244">
              <MapPinIcon className="h-4 w-4 text-emerald-300 mr-2" data-id="element-1245" />
              <span className="text-white/90 text-sm font-medium" data-id="element-1246">
                FSAI Compliant Training for Ireland
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white leading-tight" data-id="element-1247">
              Level 1 Food Safety{' '}
              <span className="text-emerald-300" data-id="element-1248">Training</span>
            </h1>
            <p className="text-xl text-white/90 mb-8 leading-relaxed max-w-xl" data-id="element-1249">
              The essential induction programme for all food handlers in
              Ireland. Fully aligned with FSAI requirements to protect consumers
              and meet your legal obligations.
            </p>
            <div className="flex flex-wrap gap-4 mb-8" data-id="element-1250">
              <div className="flex items-center bg-white/10 backdrop-blur-md px-4 py-3 rounded-lg border border-white/10 shadow-lg" data-id="element-1251">
                <ClockIcon className="h-5 w-5 text-emerald-300 mr-3 flex-shrink-0" data-id="element-1252" />
                <span className="text-white" data-id="element-1253">2 Hours</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-md px-4 py-3 rounded-lg border border-white/10 shadow-lg" data-id="element-1254">
                <AwardIcon className="h-5 w-5 text-emerald-300 mr-3 flex-shrink-0" data-id="element-1255" />
                <span className="text-white" data-id="element-1256">FSAI Compliant</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-1257">
              <a href="#enroll" className="px-6 py-3.5 bg-emerald-500 hover:bg-emerald-600 text-white font-medium rounded-lg transition-all duration-300 text-center shadow-lg flex items-center justify-center group" data-id="element-1258">
                Enroll Now - Just €19
                <ArrowRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-1259" />
              </a>
              <a href="#learn-more" className="px-6 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white font-medium rounded-lg border border-white/20 transition-all duration-300 text-center shadow-lg" data-id="element-1260">
                Learn More
              </a>
            </div>
          </div>
          <div className="relative w-full lg:w-2/5" data-id="element-1261">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white/20" data-id="element-1262">
              <img src="https://images.unsplash.com/photo-1551218808-94e220e084d2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80" alt="Food Safety Training Ireland" className="w-full h-auto" data-id="element-1263" />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-950/80 via-transparent to-transparent" data-id="element-1264"></div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white/80 backdrop-blur-md p-4 rounded-lg shadow-xl max-w-xs border border-white/50" data-id="element-1265">
              <div className="flex items-center gap-3" data-id="element-1266">
                <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0" data-id="element-1267">
                  <ShieldCheckIcon className="h-6 w-6 text-emerald-700" data-id="element-1268" />
                </div>
                <div data-id="element-1269">
                  <h3 className="font-bold text-gray-800" data-id="element-1270">
                    100% Acceptance Guarantee
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-1271">
                    Recognized by all Irish food safety inspectors
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const TargetAudienceSection = () => {
  return <section id="who-should-take" className="py-20 bg-white" data-id="element-1272">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1273">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1274">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-1275">
            <UsersIcon className="h-8 w-8 text-emerald-600" data-id="element-1276" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-1277">
            Who Should Take This Food Safety Course?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-1278">
            This Level 1 food safety training is designed for food handlers
            across Ireland
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto" data-id="element-1279">
          {[{
          icon: <BriefcaseIcon className="h-7 w-7 text-emerald-600" data-id="element-1280" />,
          title: 'Food Service Employees',
          description: 'Employees working in restaurants, cafés, hotels, catering, food retail, and production facilities throughout Ireland.'
        }, {
          icon: <UserIcon className="h-7 w-7 text-emerald-600" data-id="element-1281" />,
          title: 'Kitchen & Support Staff',
          description: 'Kitchen porters, deli staff, wait staff, and anyone handling or serving food in food businesses across Ireland.'
        }, {
          icon: <UserIcon className="h-7 w-7 text-emerald-600" data-id="element-1282" />,
          title: 'New Employees',
          description: 'New staff who must complete induction training before food handling begins, as required by FSAI guidelines.'
        }, {
          icon: <ClockIcon className="h-7 w-7 text-emerald-600" data-id="element-1283" />,
          title: 'Refresher Training',
          description: 'Employees in need of refresher training to stay compliant with FSAI guidelines and maintain food safety standards.'
        }].map((item, index) => <div key={index} className="bg-white/80 backdrop-blur-sm rounded-xl p-8 shadow-lg border border-emerald-50 hover:shadow-xl transition-shadow duration-300 flex flex-col h-full" data-id="element-1284">
              <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mb-6" data-id="element-1285">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-900" data-id="element-1286">
                {item.title}
              </h3>
              <p className="text-gray-600 flex-grow" data-id="element-1287">{item.description}</p>
            </div>)}
        </div>
        <div className="max-w-6xl mx-auto mt-16" data-id="element-1288">
          <div className="bg-emerald-50/70 backdrop-blur-sm rounded-xl p-6 border border-emerald-100 flex items-start" data-id="element-1289">
            <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1290">
              <AlertCircleIcon className="h-6 w-6 text-emerald-600" data-id="element-1291" />
            </div>
            <div data-id="element-1292">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1293">
                Is this course right for you?
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-1294">
                If you work with food in any capacity in Ireland, this Level 1
                course is your essential first step to compliance. It covers all
                the basics you need to handle food safely and meet your legal
                obligations.
              </p>
              <div className="flex flex-wrap gap-3" data-id="element-1295">
                {['Restaurants', 'Cafés', 'Hotels', 'Food Retail', 'Food Production', 'Catering', 'Takeaways'].map((item, index) => <span key={index} className="px-3 py-1 bg-emerald-100 text-emerald-800 rounded-full text-sm font-medium" data-id="element-1296">
                    {item}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const LegalRequirementsSection = () => {
  return <section id="legal-requirements" className="py-20 bg-gray-50" data-id="element-1297">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1298">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1299">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-1300">
            <ScrollIcon className="h-8 w-8 text-emerald-600" data-id="element-1301" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-1302">
            Legal Requirements for Food Safety Level 1
          </h2>
          <p className="text-xl text-gray-600" data-id="element-1303">
            Understanding your legal obligations under Irish food safety law
          </p>
        </div>
        <div className="max-w-6xl mx-auto" data-id="element-1304">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl overflow-hidden" data-id="element-1305">
            <div className="p-8 md:p-12" data-id="element-1306">
              <div className="flex flex-col md:flex-row gap-12" data-id="element-1307">
                <div className="md:w-1/2" data-id="element-1308">
                  <div className="flex items-center mb-6" data-id="element-1309">
                    <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1310">
                      <AlertCircleIcon className="h-7 w-7 text-emerald-600" data-id="element-1311" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900" data-id="element-1312">
                      Legal Requirement in Ireland
                    </h3>
                  </div>
                  <p className="text-gray-600 mb-6" data-id="element-1313">
                    In Ireland, it is a legal requirement that all food handlers
                    are trained commensurate with their work activity. The FSAI
                    Level 1 guidelines set out clear timelines for compliance.
                  </p>
                  <div className="bg-emerald-50/80 backdrop-blur-sm rounded-xl p-6 border border-emerald-100 mb-6" data-id="element-1314">
                    <h4 className="font-bold text-gray-900 mb-4" data-id="element-1315">
                      Why is this required?
                    </h4>
                    <p className="text-gray-600" data-id="element-1316">
                      This ensures that every food worker understands the
                      fundamentals of safe food handling from the very start of
                      their role, protecting public health and meeting
                      regulatory requirements.
                    </p>
                  </div>
                </div>
                <div className="md:w-1/2" data-id="element-1317">
                  <div className="space-y-6" data-id="element-1318">
                    <div className="bg-white/90 backdrop-blur-sm p-6 rounded-xl border border-gray-100 shadow-sm" data-id="element-1319">
                      <div className="flex items-center mb-4" data-id="element-1320">
                        <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1321">
                          <CalendarIcon className="h-6 w-6 text-emerald-600" data-id="element-1322" />
                        </div>
                        <div data-id="element-1323">
                          <h4 className="text-lg font-bold text-gray-900" data-id="element-1324">
                            Stage I Induction
                          </h4>
                          <p className="text-emerald-700 font-medium" data-id="element-1325">
                            Must be completed before food handling begins
                          </p>
                        </div>
                      </div>
                      <p className="text-gray-600 ml-16" data-id="element-1326">
                        Covers basic hygiene, contamination, and safe handling
                        principles.
                      </p>
                    </div>
                    <div className="bg-white/90 backdrop-blur-sm p-6 rounded-xl border border-gray-100 shadow-sm" data-id="element-1327">
                      <div className="flex items-center mb-4" data-id="element-1328">
                        <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1329">
                          <CalendarIcon className="h-6 w-6 text-emerald-600" data-id="element-1330" />
                        </div>
                        <div data-id="element-1331">
                          <h4 className="text-lg font-bold text-gray-900" data-id="element-1332">
                            Stage II Induction
                          </h4>
                          <p className="text-emerald-700 font-medium" data-id="element-1333">
                            Must be completed within the first month
                          </p>
                        </div>
                      </div>
                      <p className="text-gray-600 ml-16" data-id="element-1334">
                        Expands knowledge with more detailed food safety
                        practices and principles.
                      </p>
                    </div>
                    <div className="flex items-center" data-id="element-1335">
                      <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1336">
                        <ClipboardCheckIcon className="h-6 w-6 text-emerald-600" data-id="element-1337" />
                      </div>
                      <div data-id="element-1338">
                        <h4 className="text-lg font-bold text-gray-900" data-id="element-1339">
                          Documentation Requirements
                        </h4>
                        <p className="text-gray-600" data-id="element-1340">
                          Food businesses must maintain records of staff
                          training
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const LearningOutcomesSection = () => {
  return <section id="learning-outcomes" className="py-20 bg-white" data-id="element-1341">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1342">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1343">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-1344">
            <TargetIcon className="h-8 w-8 text-emerald-600" data-id="element-1345" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-1346">
            What You Will Learn in This Food Safety Course
          </h2>
          <p className="text-xl text-gray-600" data-id="element-1347">
            This food safety course is designed to be clear, practical, and easy
            to follow
          </p>
        </div>
        <div className="max-w-6xl mx-auto" data-id="element-1348">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1349">
            {[{
            icon: <BookOpenIcon className="h-7 w-7 text-emerald-600" data-id="element-1350" />,
            title: 'Food Safety Fundamentals',
            items: ['Explain the difference between food safety and food hygiene', 'Understand food contamination and cross-contamination']
          }, {
            icon: <CheckIcon className="h-7 w-7 text-emerald-600" data-id="element-1351" />,
            title: 'Personal Hygiene',
            items: ['Wash hands correctly and maintain personal hygiene', 'Wear and maintain uniforms or protective clothing hygienically', 'Avoid unhygienic practices when working with food']
          }, {
            icon: <ClipboardCheckIcon className="h-7 w-7 text-emerald-600" data-id="element-1352" />,
            title: 'Safe Food Handling',
            items: ['Handle, prepare, and store food safely to prevent hazards', 'Apply correct cleaning and sanitising procedures']
          }, {
            icon: <AlertCircleIcon className="h-7 w-7 text-emerald-600" data-id="element-1353" />,
            title: 'Hazard Awareness',
            items: ['Recognise the importance of allergens and HACCP in food safety', 'Identify the consequences of poor food safety management']
          }, {
            icon: <ClockIcon className="h-7 w-7 text-emerald-600" data-id="element-1354" />,
            title: 'Temperature Control',
            items: ['Understand critical temperature zones', 'Monitor food temperatures to prevent bacterial growth']
          }, {
            icon: <ShieldCheckIcon className="h-7 w-7 text-emerald-600" data-id="element-1355" />,
            title: 'HACCP Awareness',
            items: ['Understand the basic principles of HACCP', 'Prepare for advanced Level 2 HACCP training']
          }].map((item, index) => <div key={index} className="bg-white/90 backdrop-blur-sm rounded-xl p-8 shadow-lg border border-emerald-50 hover:shadow-xl transition-shadow duration-300" data-id="element-1356">
                <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mb-6" data-id="element-1357">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-4 text-gray-900" data-id="element-1358">
                  {item.title}
                </h3>
                <ul className="space-y-3" data-id="element-1359">
                  {item.items.map((listItem, i) => <li key={i} className="flex items-start" data-id="element-1360">
                      <CheckCircleIcon className="h-5 w-5 text-emerald-500 mt-0.5 mr-3 flex-shrink-0" data-id="element-1361" />
                      <span className="text-gray-600" data-id="element-1362">{listItem}</span>
                    </li>)}
                </ul>
              </div>)}
          </div>
          <div className="mt-12 bg-emerald-50/80 backdrop-blur-sm rounded-xl p-8 border border-emerald-100" data-id="element-1363">
            <div className="flex items-start" data-id="element-1364">
              <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mr-6 flex-shrink-0" data-id="element-1365">
                <GraduationCapIcon className="h-7 w-7 text-emerald-600" data-id="element-1366" />
              </div>
              <div data-id="element-1367">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1368">
                  Foundation for Advanced Training
                </h3>
                <p className="text-gray-600" data-id="element-1369">
                  This training introduces the basic principles of HACCP (Hazard
                  Analysis and Critical Control Points), providing a solid
                  foundation for further learning in Level 2 HACCP training,
                  which is legally required for those working with high-risk or
                  open foods.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const CertificationSection = () => {
  return <section id="certification" className="py-20 bg-gray-50" data-id="element-1370">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1371">
        <div className="max-w-6xl mx-auto" data-id="element-1372">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1373">
            <div data-id="element-1374">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-1375">
                <div className="h-8 w-8 text-emerald-600" data-id="element-1376" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-1377">
                Accredited Food Safety Certificate (Ireland)
              </h2>
              <p className="text-xl text-gray-600 mb-8" data-id="element-1378">
                On successful completion, you will receive a Level 1 Food Safety
                Certificate that meets all Irish regulatory requirements.
              </p>
              <div className="space-y-6" data-id="element-1379">
                {[{
                title: 'FSAI Aligned',
                description: 'Fully accredited and aligned with Food Safety Authority of Ireland Level 1 requirements'
              }, {
                title: 'Nationally Recognized',
                description: 'Recognised by Irish employers, Environmental Health Officers (EHOs), and food safety inspectors'
              }, {
                title: 'Instant Download',
                description: 'Downloadable instantly as a secure PDF once you pass the final assessment (70% pass rate)'
              }, {
                title: 'Inspection Ready',
                description: 'Valid for use as proof of training during inspections and audits'
              }].map((item, index) => <div key={index} className="flex items-start" data-id="element-1380">
                    <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1381">
                      <CheckCircleIcon className="h-5 w-5 text-emerald-600" data-id="element-1382" />
                    </div>
                    <div data-id="element-1383">
                      <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-1384">
                        {item.title}
                      </h3>
                      <p className="text-gray-600" data-id="element-1385">{item.description}</p>
                    </div>
                  </div>)}
              </div>
              <div className="mt-8 p-4 bg-amber-50/90 backdrop-blur-sm rounded-lg border border-amber-100" data-id="element-1386">
                <div className="flex items-center" data-id="element-1387">
                  <ClockIcon className="h-6 w-6 text-amber-600 mr-3 flex-shrink-0" data-id="element-1388" />
                  <p className="text-gray-700" data-id="element-1389">
                    <strong data-id="element-1390">Validity Period:</strong> Certificates should be
                    refreshed every 2–3 years or sooner if roles, legislation,
                    or company practices change.
                  </p>
                </div>
              </div>
            </div>
            <div className="relative" data-id="element-1391">
              <div className="bg-white rounded-xl shadow-xl overflow-hidden border-4 border-emerald-100" data-id="element-1392">
                <img src="https://images.unsplash.com/photo-1577301656525-dbed2a0afc20?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Food Safety Certificate Ireland" className="w-full h-auto" data-id="element-1393" />
                <div className="absolute top-0 right-0 m-4 bg-emerald-500 text-white px-4 py-2 rounded-full text-sm font-bold" data-id="element-1394">
                  FSAI Compliant
                </div>
              </div>
              <div className="absolute -bottom-8 -left-8 bg-white/90 backdrop-blur-md p-6 rounded-xl shadow-xl border border-white/70 max-w-xs" data-id="element-1395">
                <div className="flex items-center" data-id="element-1396">
                  <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1397">
                    <BuildingIcon className="h-6 w-6 text-emerald-600" data-id="element-1398" />
                  </div>
                  <div data-id="element-1399">
                    <h4 className="font-bold text-gray-900" data-id="element-1400">Team Dashboard</h4>
                    <p className="text-gray-600 text-sm" data-id="element-1401">
                      For businesses, all certificates are stored in your
                      manager dashboard for easy access during inspections.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const WhyChooseUsSection = () => {
  return <section id="why-choose-us" className="py-20 bg-white" data-id="element-1402">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1403">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1404">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-1405">
            <LightbulbIcon className="h-8 w-8 text-emerald-600" data-id="element-1406" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-1407">
            Why Choose Our Food Safety Training?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-1408">
            The perfect solution for Irish food businesses and handlers seeking
            quality, compliant training
          </p>
        </div>
        <div className="max-w-6xl mx-auto" data-id="element-1409">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1410">
            {[{
            icon: <GraduationCapIcon className="h-7 w-7 text-emerald-600" data-id="element-1411" />,
            title: '100% Online Learning',
            description: 'Study at your own pace, anytime, anywhere on any device.'
          }, {
            icon: <FileTextIcon className="h-7 w-7 text-emerald-600" data-id="element-1412" />,
            title: 'Interactive Video Lessons',
            description: 'Engaging content with unlimited playback to ensure understanding.'
          }, {
            icon: <CheckCircleIcon className="h-7 w-7 text-emerald-600" data-id="element-1413" />,
            title: 'Knowledge Checkpoints',
            description: 'Multiple-choice quizzes to test your knowledge throughout.'
          }, {
            icon: <AwardIcon className="h-7 w-7 text-emerald-600" data-id="element-1414" />,
            title: 'Unlimited Assessment Attempts',
            description: 'No extra charges for retaking assessments until you pass.'
          }, {
            icon: <ClockIcon className="h-7 w-7 text-emerald-600" data-id="element-1415" />,
            title: 'Immediate Certification',
            description: 'Download your certificate instantly upon completion.'
          }, {
            icon: <MapPinIcon className="h-7 w-7 text-emerald-600" data-id="element-1416" />,
            title: 'Ireland-Specific Content',
            description: 'Designed specifically for Irish food safety legislation.'
          }].map((feature, index) => <div key={index} className="bg-white/90 backdrop-blur-sm rounded-xl p-8 shadow-lg border border-emerald-50 hover:shadow-xl transition-shadow duration-300" data-id="element-1417">
                <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mb-6" data-id="element-1418">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-1419">
                  {feature.title}
                </h3>
                <p className="text-gray-600" data-id="element-1420">{feature.description}</p>
              </div>)}
          </div>
          <div className="mt-16 bg-gradient-to-r from-emerald-800 to-emerald-700 rounded-xl p-8 shadow-lg text-white overflow-hidden relative" data-id="element-1421">
            <div className="absolute inset-0 opacity-10" data-id="element-1422">
              <div className="absolute inset-0" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
              backgroundSize: '24px 24px'
            }} data-id="element-1423"></div>
            </div>
            {/* Liquid glass effect blobs */}
            <div className="absolute top-1/3 -right-10 w-40 h-40 rounded-full bg-white/10 blur-3xl" data-id="element-1424"></div>
            <div className="absolute bottom-1/3 -left-10 w-40 h-40 rounded-full bg-white/5 blur-3xl" data-id="element-1425"></div>
            <div className="flex flex-col md:flex-row items-center gap-8 relative z-10" data-id="element-1426">
              <div className="md:w-3/4" data-id="element-1427">
                <h3 className="text-2xl font-bold mb-4" data-id="element-1428">
                  Trusted by 5,000+ Irish Food Businesses
                </h3>
                <p className="text-white/90 mb-6" data-id="element-1429">
                  From small cafés to major restaurant chains and retailers, our
                  certification is trusted industry-wide to meet Irish
                  compliance requirements.
                </p>
                <div className="flex flex-wrap gap-3" data-id="element-1430">
                  {['Dunnes Stores', 'SuperValu', 'Avoca', 'Musgrave Group', 'And many more...'].map((item, index) => <span key={index} className="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium border border-white/10" data-id="element-1431">
                      {item}
                    </span>)}
                </div>
              </div>
              <div className="md:w-1/4" data-id="element-1432">
                <a href="#enroll" className="w-full px-6 py-4 bg-white/20 backdrop-blur-md border border-white/30 text-white font-bold rounded-lg hover:bg-white/30 transition-all duration-300 text-center shadow-lg inline-block" data-id="element-1433">
                  Get Certified Today
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const FaqSection = () => {
  const [openQuestion, setOpenQuestion] = useState(null);
  const toggleQuestion = id => {
    setOpenQuestion(openQuestion === id ? null : id);
  };
  const faqs = [{
    id: 1,
    question: 'Is food safety training mandatory in Ireland?',
    answer: 'Yes. All food handlers must complete food safety training that matches their work activity. Level 1 is the legal minimum for new employees in food businesses in Ireland, as required by the Food Safety Authority of Ireland (FSAI).'
  }, {
    id: 2,
    question: 'When must training be completed?',
    answer: 'According to FSAI requirements, Stage I induction training must be completed before food handling begins, and Stage II within the first month of employment. This course covers both stages to ensure full compliance.'
  }, {
    id: 3,
    question: 'How long does the certificate last?',
    answer: 'Certificates should be refreshed every 2–3 years or when legislation, company procedures, or your role changes. This is in line with FSAI best practice guidance for food businesses in Ireland.'
  }, {
    id: 4,
    question: 'Who recognises this certificate?',
    answer: 'The certificate is recognised by Irish employers, Environmental Health Officers (EHOs), and food safety inspectors as proof of compliance with FSAI guidelines. It can be presented during official inspections and audits.'
  }, {
    id: 5,
    question: 'Do I need Level 2 HACCP training?',
    answer: 'Yes, if you prepare or handle high-risk or open foods, you must complete Level 2 Food Safety (HACCP) training within 3 months of starting work. This is an additional requirement beyond the Level 1 training.'
  }, {
    id: 6,
    question: 'How do I access the course?',
    answer: 'Once enrolled, you can access the course immediately through our online learning platform. The course is 100% online and can be completed on any device with internet access - computer, tablet, or smartphone.'
  }];
  return <section id="faq" className="py-20 bg-gray-50" data-id="element-1434">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1435">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1436">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-1437">
            <ChevronDownIcon className="h-8 w-8 text-emerald-600" data-id="element-1438" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-1439">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600" data-id="element-1440">
            Find answers to common questions about our Level 1 Food Safety
            course for Ireland
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-1441">
          {faqs.map(faq => <div key={faq.id} className="mb-4 bg-white/90 backdrop-blur-sm rounded-xl shadow-sm overflow-hidden" data-id="element-1442">
              <button onClick={() => toggleQuestion(faq.id)} className="flex items-center justify-between w-full p-6 text-left focus:outline-none" data-id="element-1443">
                <h3 className="text-lg font-bold text-gray-900" data-id="element-1444">
                  {faq.question}
                </h3>
                <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 transition-transform duration-300" data-id="element-1445">
                  {openQuestion === faq.id ? <MinusIcon className="h-4 w-4 text-emerald-600" data-id="element-1446" /> : <PlusIcon className="h-4 w-4 text-emerald-600" data-id="element-1447" />}
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openQuestion === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-1448">
                <div className="p-6 pt-0 border-t border-gray-100" data-id="element-1449">
                  <p className="text-gray-600" data-id="element-1450">{faq.answer}</p>
                </div>
              </div>
            </div>)}
          <div className="mt-12 text-center" data-id="element-1451">
            <p className="text-gray-600 mb-4" data-id="element-1452">
              Still have questions about the food safety course?
            </p>
            <a href="/contact" className="inline-flex items-center text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-1453">
              Contact our support team
              <ChevronRightIcon className="ml-1 h-5 w-5" data-id="element-1454" />
            </a>
          </div>
        </div>
      </div>
    </section>;
};
const CtaSection = () => {
  return <section id="enroll" className="py-20 bg-emerald-900 relative overflow-hidden" data-id="element-1455">
      {/* Liquid glass effect blobs */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-1456">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full bg-emerald-600/20 blur-3xl" data-id="element-1457"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-emerald-400/10 blur-3xl" data-id="element-1458"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-1459">
        <div className="max-w-5xl mx-auto bg-white/10 backdrop-blur-md rounded-2xl shadow-2xl overflow-hidden border border-white/20" data-id="element-1460">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-1461">
            <div className="p-8 md:p-12 lg:p-16" data-id="element-1462">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-1463">
                <CreditCardIcon className="h-8 w-8 text-emerald-600" data-id="element-1464" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-1465">
                Enroll Today – Start Your Level 1 Food Safety Training
              </h2>
              <p className="text-white/80 mb-8" data-id="element-1466">
                Meet your legal requirements, protect your customers, and gain
                accredited certification with our Food Safety Level 1 Course for
                Ireland. Whether you're just starting out or refreshing your
                skills, this course provides the essential foundation for safe
                food handling.
              </p>
              <div className="space-y-4 mb-8" data-id="element-1467">
                <div className="flex items-center" data-id="element-1468">
                  <CheckCircleIcon className="h-5 w-5 text-emerald-300 mr-3" data-id="element-1469" />
                  <span className="text-white/90" data-id="element-1470">
                    Complete in just 2 hours
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1471">
                  <CheckCircleIcon className="h-5 w-5 text-emerald-300 mr-3" data-id="element-1472" />
                  <span className="text-white/90" data-id="element-1473">
                    FSAI compliant certification
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1474">
                  <CheckCircleIcon className="h-5 w-5 text-emerald-300 mr-3" data-id="element-1475" />
                  <span className="text-white/90" data-id="element-1476">
                    Instant access and certificate
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1477">
                  <CheckCircleIcon className="h-5 w-5 text-emerald-300 mr-3" data-id="element-1478" />
                  <span className="text-white/90" data-id="element-1479">
                    100% acceptance guarantee
                  </span>
                </div>
              </div>
              <a href="/checkout" className="inline-block px-8 py-4 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-lg transition-all duration-300 shadow-lg border border-emerald-500/50" data-id="element-1480">
                Enroll Now - Just €19
              </a>
            </div>
            <div className="relative" data-id="element-1481">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-700/70 to-emerald-900/70 backdrop-blur-sm" data-id="element-1482"></div>
              <img src="https://images.unsplash.com/photo-1590779033100-9f60a05a013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80" alt="Food Safety Certification" className="w-full h-full object-cover" data-id="element-1483" />
              <div className="absolute inset-0 flex items-center justify-center p-8" data-id="element-1484">
                <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 max-w-md text-white border border-white/20 shadow-xl" data-id="element-1485">
                  <div className="flex items-center mb-6" data-id="element-1486">
                    <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center mr-4" data-id="element-1487">
                      <StarIcon className="h-6 w-6 text-yellow-300" data-id="element-1488" />
                    </div>
                    <div data-id="element-1489">
                      <h3 className="text-xl font-bold" data-id="element-1490">
                        Trusted by Professionals
                      </h3>
                      <div className="flex mt-1" data-id="element-1491">
                        {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="h-5 w-5 text-yellow-300" data-id="element-1492" />)}
                      </div>
                    </div>
                  </div>
                  <blockquote className="mb-6 italic" data-id="element-1493">
                    "This course was perfect for our team. Clear, concise
                    information that meets all our FSAI requirements. The staff
                    found it easy to follow and we were all certified within a
                    day."
                  </blockquote>
                  <div className="flex items-center" data-id="element-1494">
                    <div className="w-10 h-10 rounded-full overflow-hidden mr-3" data-id="element-1495">
                      <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Customer" className="w-full h-full object-cover" data-id="element-1496" />
                    </div>
                    <div data-id="element-1497">
                      <p className="font-medium" data-id="element-1498">Michael O'Connor</p>
                      <p className="text-sm text-white/80" data-id="element-1499">
                        Restaurant Manager, Dublin
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};